module.exports = __webpack_public_path__ + "img/header-0.3334661.jpeg";